import { render, staticRenderFns } from "./FormDocumentsValidationInfo.vue?vue&type=template&id=722a4a45&scoped=true&lang=pug&"
import script from "./FormDocumentsValidationInfo.vue?vue&type=script&lang=js&"
export * from "./FormDocumentsValidationInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormDocumentsValidationInfo.vue?vue&type=style&index=0&id=722a4a45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722a4a45",
  null
  
)

export default component.exports